import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hooksV2Api } from '../../../services/apiV2';
import { MasteryRow } from '../../../types/v2';
import TeacherNav from '../../../components/TeacherNav';
import { AppShell } from '../../../components/layout/AppShell';
import { teacherV2NavItems } from '../../../components/layout/v2NavItems';
import { isUiRedesignPageEnabled } from '../../../config/uiRedesign';

export const V2MasteryOverview: React.FC = () => {
  const { hookId } = useParams();
  const redesignEnabled = isUiRedesignPageEnabled('v2_teacher_mastery_overview');
  const [rows, setRows] = useState<MasteryRow[]>([]);

  const load = async () => {
    if (!hookId) return;
    const response = await hooksV2Api.mastery(Number(hookId));
    setRows(response.data.mastery || []);
  };

  useEffect(() => {
    load();
  }, [hookId]);

  const unlockApply = async (studentId: number) => {
    if (!hookId) return;
    await hooksV2Api.unlockApply(Number(hookId), studentId);
    load();
  };

  const pageContent = (
    <div className={redesignEnabled ? 'mx-auto max-w-6xl' : 'max-w-6xl mx-auto p-6'}>
      <h1 className="text-2xl font-semibold text-gray-900">Mastery Overview</h1>
      <div className="mt-4 space-y-2">
        {rows.map((row) => (
          <div key={`${row.student_id}-${row.hook_assignment_id}`} className="bg-white rounded shadow p-3 flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Student ID: {row.student_id}</p>
              <p className="text-sm text-gray-700">Status: {row.status}</p>
            </div>
            <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={() => unlockApply(row.student_id)}>
              Unlock Apply
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  return redesignEnabled ? (
    <AppShell role="teacher" navItems={teacherV2NavItems('reports')} title="Reports">
      {pageContent}
    </AppShell>
  ) : (
    <>
      <TeacherNav activeTab="reports" />
      {pageContent}
    </>
  );
};
